module.exports = __webpack_public_path__ + "static/media/RVS-logo.9ed76aeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/RVS-logo.svg
// module id = 166
// module chunks = 0